/**
 * SubscriptionBadge Component
 * Small tier indicator badge for header/UI
 */

import { SubscriptionTier } from '@talktoast/shared/types/subscription'

interface SubscriptionBadgeProps {
  tier: SubscriptionTier
  size?: 'sm' | 'md' | 'lg'
  showIcon?: boolean
}

export function SubscriptionBadge({ tier, size = 'md', showIcon = true }: SubscriptionBadgeProps) {
  const config: Record<string, { label: string; colors: string }> = {
    free: {
      label: 'Free',
      colors: 'bg-gray-100 text-gray-700 border-gray-300'
    },
    premium: {
      label: 'Premium',
      colors: 'bg-gradient-to-r from-yellow-50 to-orange-50 text-orange-700 border-orange-300'
    }
  }

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-3 py-1',
    lg: 'text-base px-4 py-1.5'
  }

  // Fallback to premium styling for any legacy 'pro' DB rows — intentional, do not remove
  const { label, colors } = config[tier] ?? config.premium

  return (
    <span
      className={`
        inline-flex items-center rounded-full border font-semibold
        ${colors}
        ${sizeClasses[size]}
      `}
    >
      <span>{label}</span>
    </span>
  )
}
